import DetailsPanel from './DetailsPanel';
import BiospecimenDetails from './BiospecimenDetails';
import CaseDetails from './CaseDetails';
import TransactionDetails from './TransactionDetails';
import CaseOverviewDetails from './CaseOverviewDetails';
import VerticalTable from './VerticalTable';
import DynamicEntityDetails from './DynamicEntityDetails';
import AnnotationDetails from './AnnotationDetails';

export {
  DetailsPanel,
  BiospecimenDetails,
  CaseDetails,
  TransactionDetails,
  CaseOverviewDetails,
  VerticalTable
};

export function DetailsRegistry(entity, defs) {
  const biospecimenDetails = defs
    .filter(d => d.category === 'biospecimen')
    .reduce((acc, d) => {
      return {...acc, [d.id]: BiospecimenDetails};
    }, {});

  const entityToDetails = {
    ...biospecimenDetails,
    'case': CaseDetails,
    'annotation': AnnotationDetails,
  };
  return entityToDetails[entity] || DynamicEntityDetails;
}
